// @flow
import type { Handbook } from 'types'
import { apiError, get, post, put } from 'util/api'

export function upsert(
  schoolId: number,
  handbook: Handbook,
  changeSummary?: string,
): Promise<Handbook> {
  return post(`/api/schools/${schoolId}/handbook`, { handbook, changeSummary })
    .then(response => response.json.handbook)
    .catch(response => {
      throw apiError(response.json)
    })
}

export function createEditable(
  schoolId: number,
  handbook: Handbook,
  changeSummary?: string,
): Promise<Handbook> {
  return post(`/api/schools/${schoolId}/editable-handbook`, { handbook, changeSummary })
    .then(response => response.json.handbook)
    .catch(response => {
      throw apiError(response.json)
    })
}

export function updateEditable(
  schoolId: number,
  handbook: Handbook,
  changeSummary?: string,
): Promise<Handbook> {
  return put(`/api/schools/${schoolId}/editable-handbook`, { handbook, changeSummary })
    .then(response => response.json.handbook)
    .catch(response => {
      throw apiError(response.json)
    })
}

export function updateHideFromProfile(
  schoolId: number,
  hideFromProfile: Boolean,
): Promise<Handbook> {
  return put(`/api/schools/${schoolId}/editable-handbook/hidden-from-profile`, { hideFromProfile })
    .then(response => response.json.handbook)
    .catch(response => {
      throw apiError(response.json)
    })
}

export function fetch(schoolId: number): Promise<Handbook> {
  return get(`/api/schools/${schoolId}/handbook`)
    .then(response => response.json.handbook)
    .catch(response => {
      throw apiError(response.json)
    })
}

export function fetchEditable(schoolId: number): Promise<Handbook> {
  return get(`/api/schools/${schoolId}/editable-handbook`)
    .then(response => response.json.handbook)
    .catch(response => {
      throw apiError(response.json)
    })
}

export function fetchEditableBySlug(slug: string): Promise<Handbook> {
  return get(`/api/schools/slug/${slug}/editable-handbook`)
    .then(response => response.json.handbook)
    .catch(response => {
      throw apiError(response.json)
    })
}

export function fetchBySlug(slug: string): Promise<Handbook> {
  return get(`/api/schools/slug/${slug}/handbook`)
    .then(response => response.json.handbook)
    .catch(response => {
      throw apiError(response.json)
    })
}

export function fetchEditableHTML(schoolId: number): Promise<string> {
  return get(`/api/schools/${schoolId}/editable-handbook?format=html`)
    .then(response => response.json.handbook)
    .catch(response => {
      throw apiError(response.json)
    })
}

export function fetchHTML(schoolId: number): Promise<string> {
  return get(`/api/schools/${schoolId}/handbook?format=html`)
    .then(response => response.json.handbook)
    .catch(response => {
      throw apiError(response.json)
    })
}

export function fetchTemplates(schoolId: number): Promise<Handbook> {
  return get(`/api/schools/${schoolId}/handbook/templates`)
    .then(response => response.json.templates)
    .catch(response => {
      throw apiError(response.json)
    })
}

export function fetchEditableTemplates(schoolId: number): Promise<Handbook> {
  return get(`/api/schools/${schoolId}/handbook/editable-templates`)
    .then(response => response.json.templates)
    .catch(response => {
      throw apiError(response.json)
    })
}
